// Локальные отметки для целей Метрики тоггла (business_apps#1486 §4.4):
// день первого показа тоггла и флаг «просмотр варианта уже отправлен в визите».

import dayjs from 'dayjs'
import { STORAGE_KEYS } from './constants'

const read = (storage, key) => {
  try {
    return window[storage].getItem(key)
  } catch (error) {
    return null
  }
}

const write = (storage, key, value) => {
  try {
    window[storage].setItem(key, value)
  } catch (error) {
    // приватный режим / запрет storage
  }
}

export const markToggleSeen = () => {
  if (!read('localStorage', STORAGE_KEYS.toggleFirstSeen)) {
    write(
      'localStorage',
      STORAGE_KEYS.toggleFirstSeen,
      dayjs().format('YYYY-MM-DD')
    )
  }
}

export const daysSinceToggleFirstSeen = () => {
  const firstSeen = read('localStorage', STORAGE_KEYS.toggleFirstSeen)
  if (!firstSeen) return 0
  const diff = dayjs().diff(dayjs(firstSeen), 'day')
  return Number.isFinite(diff) && diff > 0 ? diff : 0
}

export const variantViewedThisVisit = () =>
  read('sessionStorage', STORAGE_KEYS.variantViewed) === '1'

export const markVariantViewed = () =>
  write('sessionStorage', STORAGE_KEYS.variantViewed, '1')
